export class DateHelper {

	static DAYS_OF_WEEK = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa']
	static DAY_INDICES = {
		su: 0,
		mo: 1,
		tu: 2,
		we: 3,
		th: 4,
		fr: 5,
		sa: 6
	}
	static MIN_OF_24_H = 24 * 60

	
	static formatDateTime = (date, includeTodyDate) => {
		if (!date) {
			return null
		}
		if (!includeTodyDate && new Date().getDate() === date.getDate()) {
			return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
		}
		else {
			return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${includeTodyDate ? String(date.getFullYear()) : ''} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
		}
	}

	static getHourMinuteOfDate = date => `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`

	static getHourMinuteSecondsMilliesOfDate = date => `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}.${String(date.getMilliseconds()).padStart(3, '0')}`

	static getIsoFormatOfDate = date => `${String(date.getFullYear())}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

	static getIsoFormatOfDateTime = date => `${DateHelper.getIsoFormatOfDate(date)}T${DateHelper.getHourMinuteSecondsMilliesOfDate(date)}`

}